export const tr = {
    'normal-view-title': 'Reklamlara hızlı bağlantılar ekleyin',
    'normal-view-title-hint': 'Hızlı bağlantı içermeyen reklamlarınız olduğu için bu öneriyi görüyorsunuz',
    'popup-view-title': 'Reklama hızlı bağlantılar ekleyin',
    'popup-view-title-hint': 'Reklamınız hızlı bağlantılar içermediği için bu öneriyi görüyorsunuz',
    'show-many-banner-button': '{count} reklamı görüntüle',
    'show-one-banner-button': '{count} reklamı görüntüle',
    'show-some-banner-button': '{count} reklamı görüntüle',
    'site-links-desc1':
        'Hızlı bağlantılar, ek harcama yapmadan reklamın tıklama oranının artmasını sağlar. Reklamı görüntüleyen kullanıcı birden fazla bağlantıya tıklarsa sadece bir tıklama için ödeme yapılır.',
    'site-links-desc2':
        'Hızlı bağlantılarda teklifinizin özelliklerini ve teslim koşullarını açıklayabilir ve gerekirse reklamın ana metnine sığmayan diğer bilgileri ekleyebilirsiniz.'
};
